import * as t from "io-ts";

export enum AppKind {
    App = "app",
    Page = "page",
}

export function getAppKindDisplayName(appKind: AppKind): string {
    return appKind !== AppKind.Page ? "App" : "Page";
}

export const appKindCodec = t.union([t.literal(AppKind.App), t.literal(AppKind.Page)]);
